import axios from "axios";

// Create Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:3000/api/v2",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach Token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response Interceptor: Unwrap Data & Uniform Error Handling
apiClient.interceptors.response.use(
  (response) => {
    // Backend returns { success: true, data: ... }
    // We unwrap and return only 'data'
    if (
      response.data &&
      response.data.success &&
      response.data.data !== undefined
    ) {
      return response.data.data;
    }
    // Fallback for non-standard responses or direct data
    return response.data;
  },
  (error) => {
    // Standardize error object
    const errorResponse = {
      message: "Bir hata oluştu.",
      code: "UNKNOWN_ERROR",
      originalError: error,
    };

    if (error.response && error.response.data) {
      const backendError = error.response.data.error; // New backend format { error: { code, message } }

      if (backendError) {
        errorResponse.message = backendError.message || errorResponse.message;
        errorResponse.code = backendError.code || errorResponse.code;
      } else if (error.response.data.message) {
        // Fallback or legacy format
        errorResponse.message = error.response.data.message;
      }
    } else if (error.message) {
      errorResponse.message = error.message;
    }

    // Attach formatted error to the rejected promise so components can access it easily
    // We modify the error object itself to keep axios structure but add our formatted message
    error.formatted = errorResponse;

    // Also update the main message for easier access
    error.message = errorResponse.message;

    return Promise.reject(error);
  },
);

export default apiClient;
